import { ReactSVG } from "react-svg"

const formatFeatureName = (key) =>
    key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase());

const getAccessStatus = (features) => {
    if (!features) {
        return { status: "No Access", badges: [] };
    }

    // If user has all access
    if (features.all) {
        return { status: "All Features", badges: [] };
    }

    // Collect all enabled features (including nested ones)
    const enabledFeatures = [];

    // Check top-level features
    const topLevelFeatures = ["dashboard", "fabrics", "style_accents", "report", "transactions"];
    topLevelFeatures.forEach(feature => {
        if (features[feature] === true) {
            enabledFeatures.push(feature);
        }
    });

    // Check nested master features
    if (features.master && typeof features.master === "object") {
        Object.entries(features.master).forEach(([key, value]) => {
            if (value === true) {
                enabledFeatures.push(`master.${key}`);
            }
        });
    }

    // Determine status
    if (enabledFeatures.length === 0) {
        return { status: "No Access", badges: [] };
    }

    return { status: "Some Features", badges: enabledFeatures };
};

const columns = [
    {
        name: "Name",
        selector: (row) => row.name,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Email",
        selector: (row) => row.email,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Phone Number",
        selector: (row) => row.phone_number,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Features Access",
        selector: (row) => {
            const { status, badges } = getAccessStatus(row.features_access_user);

            if (status === "No Access") {
                return <p>No Access</p>;
            }

            if (status === "All Features") {
                return <p>All Features</p>;
            }

            // Some Features
            return (
                <p>
                    Some Features ({badges.length})
                </p>
            );
        },
        sortable: false,
    }
]

export default columns
